import { AUTH_IDENTITY_SESSION_KEY } from "../config/constants";

/**
 * What the email screen learned, carried to the screen it sends the visitor to.
 * Storage rather than state: those screens have URLs of their own.
 */
export interface IAuthIdentity {
  email: string;
  /** Absent for an address with no account — nobody to greet yet. */
  firstName?: string;
}

export const getAuthIdentity = (): IAuthIdentity | undefined => {
  try {
    const raw = window.sessionStorage.getItem(AUTH_IDENTITY_SESSION_KEY);
    if (!raw) return undefined;

    const parsed: unknown = JSON.parse(raw);
    // Without an address there is nothing to log in.
    if (
      typeof parsed !== "object" ||
      parsed === null ||
      typeof (parsed as IAuthIdentity).email !== "string"
    )
      return undefined;

    return parsed as IAuthIdentity;
  } catch {
    // Unparseable, or storage refused (Safari private mode).
    return undefined;
  }
};

export const setAuthIdentity = (identity: IAuthIdentity) => {
  try {
    window.sessionStorage.setItem(
      AUTH_IDENTITY_SESSION_KEY,
      JSON.stringify(identity)
    );
  } catch {
    /* no-op — the screen it feeds redirects back. */
  }
};

/** Once authenticated there is a session to read instead. */
export const clearAuthIdentity = () => {
  try {
    window.sessionStorage.removeItem(AUTH_IDENTITY_SESSION_KEY);
  } catch {
    /* no-op */
  }
};
